import { useEffect, useState } from "react";
import { useLocation, Link, NavLink } from "react-router-dom";
import { getBasicPropertydetails } from "../../Services/Service";

const SideBar = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [Pms, setPMS] = useState();


    const isPathActive = (path) => currentPath === path;

    const isPropertyDetailsActive = [
        "/Property/propertyDetails",
        "/Property/contact",
        "/Property/propertylocation",
        "/Property/Amenities",
        "/Property/Bankdetail",
        "/Property/room",
        "/Property/Gstdetail",
        "/Property/RateCodeList",
        "/Property/MealPlanList",
        "/Property/RateInventory",
        "/Property/BulkUpdateCalender",
        // "/Property/BulkUpdateRate",
        "/Property/VoucherEdit"
    ].some(path => currentPath.startsWith(path));

    const isBasicInfoActive = [
        "/Property/propertyDetails",
        "/Property/contact",
        "/Property/propertylocation"
    ].some(path => currentPath.startsWith(path));


    const isBookingDetailsActive = [
        "/Property/NewBooking",
        "/Property/Bookinglist"
    ].some(path => currentPath.startsWith(path));

    const isInventoryDetailsActive = ["/Property/RateUpdateForm"].some(path => currentPath.startsWith(path));
    const isAgentDetailsActive = ["/Property/NewAgent", "/Property/AgentList"].some(path => currentPath.startsWith(path));
    const isCompanyDetailsActive = ["/Property/Newcompany", "/Property/companyList"].some(path => currentPath.startsWith(path));
    const isMarketSegmentActive = ["/Property/MarketSagmentList"].some(path => currentPath.startsWith(path));
    const isBusinssSourceActive = ["/Property/BusinessSourceList"].some(path => currentPath.startsWith(path));
    const isGuaranteeCodesActive = ["/Property/GuaranteeCodes"].some(path => currentPath.startsWith(path));
    const isReportActive = ["/Property/Report", "/Property/TodayBookingReport", "/Property/AgentReport", "/Property/CorporateBookingReport"].some(path => currentPath.startsWith(path));


    useEffect(() => {
        const timer = setTimeout(() => {
            const wrapper = document.querySelector('.wrapper');
            if (wrapper && !wrapper.classList.contains('sidebar_minimize')) {
                wrapper.classList.add('sidebar_minimize');
            }
            const toggleSidebarBtn = document.querySelector('.toggle-sidebar');
            const sidenavTogglerBtn = document.querySelector('.sidenav-toggler');
            const topbarTogglerBtn = document.querySelector('.topbar-toggler');
            const sidebarElement = document.querySelector('.sidebar');

            const toggleSidebar = () => {
                console.log('Toggle triggered');
                if (wrapper) wrapper.classList.toggle('sidebar_minimize');
            };

            const handleMouseEnter = () => {
                if (wrapper && wrapper.classList.contains('sidebar_minimize')) {
                    wrapper.classList.add('sidebar_minimize_hover');
                }
            };

            const handleMouseLeave = () => {
                if (wrapper) wrapper.classList.remove('sidebar_minimize_hover');
            };

            toggleSidebarBtn?.addEventListener('click', toggleSidebar);
            sidenavTogglerBtn?.addEventListener('click', toggleSidebar);
            topbarTogglerBtn?.addEventListener('click', toggleSidebar);
            sidebarElement?.addEventListener('mouseenter', handleMouseEnter);
            sidebarElement?.addEventListener('mouseleave', handleMouseLeave);

            return () => {
                toggleSidebarBtn?.removeEventListener('click', toggleSidebar);
                sidenavTogglerBtn?.removeEventListener('click', toggleSidebar);
                topbarTogglerBtn?.removeEventListener('click', toggleSidebar);
                sidebarElement?.removeEventListener('mouseenter', handleMouseEnter);
                sidebarElement?.removeEventListener('mouseleave', handleMouseLeave);
            };
        }, 0);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const FetchPMS = async () => {
            try {
                const result = await getBasicPropertydetails();
                if (result && result.length > 0) {
                    setPMS(result[0]);
                }
            }
            catch (error) {
                console.log("error fetch Pms in get api", error);
            }
        }
        FetchPMS();
    }, [])

    const pmsValue = Pms?.PMS ?? null;
    const showMealPlan = pmsValue ? (pmsValue === "IdsNext" || pmsValue === "Opera") : true;
    const showRateCode = pmsValue ? (pmsValue === "Opera") : true;

    return (
        <div className="sidebar" data-background-color="dark">
            <div className="sidebar-logo">
                <div className="logo-header" data-background-color="dark">
                    <Link to="/" className="logo">
                        <img
                            src="../assets/img/BookOnNile Logo.svg"
                            alt="navbar brand"
                            className="navbar-brand"
                            style={{ backgroundColor: "#fff", padding: "4px", width: "60px", margin: "0 auto", height: "49px" }}
                        />
                    </Link>
                    <div className="nav-toggle">
                        <button className="btn btn-toggle toggle-sidebar"><i className="gg-menu-right" /></button>
                        <button className="btn btn-toggle sidenav-toggler"><i className="gg-menu-left" /></button>
                    </div>
                    <button className="topbar-toggler more"><i className="gg-more-vertical-alt" /></button>
                </div>
            </div>

            <div className="sidebar-wrapper scrollbar-inner">
                <div className="sidebar-content">
                    <ul className="nav nav-secondary">
                        <li className={isPathActive("/Property/Login") ? "nav-item active" : "nav-item"}>
                            <NavLink to="/Property/Login" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <i className="fas fa-home" /><p>Home</p>
                            </NavLink>
                        </li>

                        <li className={isPathActive("/Property/Dashboard") ? "nav-item active" : "nav-item"}>
                            <NavLink to="/Property/Dashboard" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <i className="fas fa-tachometer-alt" /><p>Dashboard</p>
                            </NavLink>
                        </li>

                        {/* <li className="nav-section">
                            <span className="sidebar-mini-icon"><i className="fa fa-ellipsis-h" /></span>
                            <h4 className="text-section">Components</h4>
                        </li> */}

                        {/* Property Details */}
                        <li className={`nav-item ${isPropertyDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#propertyDetails" aria-expanded={isPropertyDetailsActive}>
                                <i className="fas fa-building" /><p>Property Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isPropertyDetailsActive ? "show" : ""}`} id="propertyDetails">
                                <ul className="nav nav-collapse">
                                    <li>
                                        <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#basicInfo" aria-expanded={isBasicInfoActive}>
                                            <span className="sub-item">Basic Info</span><span className="caret" />
                                        </a>
                                        <div className={`collapse ${isBasicInfoActive ? "show" : ""}`} id="basicInfo">
                                            <ul className="nav nav-collapse subnav">
                                                <li className={isPathActive("/Property/propertyDetails") ? "active" : ""}>
                                                    <NavLink to="/Property/propertyDetails" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                                        <span className="sub-item">Property Details</span>
                                                    </NavLink>
                                                </li>
                                                <li className={isPathActive("/Property/contact") ? "active" : ""}>
                                                    <NavLink to="/Property/contact" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                                        <span className="sub-item">Contact</span>
                                                    </NavLink>
                                                </li>
                                                <li className={isPathActive("/Property/propertylocation") ? "active" : ""}>
                                                    <NavLink to="/Property/propertylocation" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                                        <span className="sub-item">Location & Direction</span>
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className={isPathActive("/Property/Amenities") ? "active" : ""}>
                                        <NavLink to="/Property/Amenities" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Amenities</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/Bankdetail") ? "active" : ""}>
                                        <NavLink to="/Property/Bankdetail" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Bank Details</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/room") ? "active" : ""}>
                                        <NavLink to="/Property/room" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Rooms</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/Gstdetail") ? "active" : ""}>
                                        <NavLink to="/Property/Gstdetail" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">GST Details</span>
                                        </NavLink>
                                    </li>
                                    {showRateCode && (
                                        <li className={isPathActive("/Property/RateCodeList") ? "active" : ""}>
                                            <NavLink to="/Property/RateCodeList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                                <span className="sub-item">Rate Code</span>
                                            </NavLink>
                                        </li>
                                    )}
                                    {showMealPlan && (
                                        <li className={isPathActive("/Property/MealPlanList") ? "active" : ""}>
                                            <NavLink to="/Property/MealPlanList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                                <span className="sub-item">Meal Plan</span>
                                            </NavLink>
                                        </li>
                                    )}
                                    <li className={isPathActive("/Property/RateInventory") ? "active" : ""}>
                                        <NavLink to="/Property/RateInventory" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Rate Inventory</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/BulkUpdateCalender") ? "active" : ""}>
                                        <NavLink to="/Property/BulkUpdateCalender" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Bulk Updates</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/VoucherEdit") ? "active" : ""}>
                                        <NavLink to="/Property/VoucherEdit" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Voucher Edit</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* Booking Details */}
                        <li className={`nav-item ${isBookingDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#bookingDetails" aria-expanded={isBookingDetailsActive}>
                                <i className="fas fa-calendar-check" /><p>Booking Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isBookingDetailsActive ? "show" : ""}`} id="bookingDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Property/NewBooking") ? "active" : ""}>
                                        <NavLink to="/Property/NewBooking" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">New Booking</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/Bookinglist") ? "active" : ""}>
                                        <NavLink to="/Property/Bookinglist" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Booking List</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* Inventory Details */}
                        <li className={`nav-item ${isInventoryDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#inventoryDetails" aria-expanded={isInventoryDetailsActive}>
                                <i className="fas fa-align-left" /><p>Inventory Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isInventoryDetailsActive ? "show" : ""}`} id="inventoryDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Property/RateUpdateForm") ? "active" : ""}>
                                        <NavLink to="/Property/RateUpdateForm" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Bulk Room Rate</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* Agent Details */}
                        <li className={`nav-item ${isAgentDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#agentDetails" aria-expanded={isAgentDetailsActive}>
                                <i className="fas fa-user-tie" /><p>Agent Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isAgentDetailsActive ? "show" : ""}`} id="agentDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Property/NewAgent") ? "active" : ""}>
                                        <NavLink to="/Property/NewAgent" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">New Agent</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/AgentList") ? "active" : ""}>
                                        <NavLink to="/Property/AgentList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Agent List</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* Company Details */}
                        <li className={`nav-item ${isCompanyDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#companyDetails" aria-expanded={isCompanyDetailsActive}>
                                <i className="fas fa-building" /><p>Company Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isCompanyDetailsActive ? "show" : ""}`} id="companyDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Property/Newcompany") ? "active" : ""}>
                                        <NavLink to="/Property/Newcompany" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">New Company</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/companyList") ? "active" : ""}>
                                        <NavLink to="/Property/companyList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Company List</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* Market Segment */}

                        <li className={`nav-item ${isMarketSegmentActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#MarketSegmentDetails" aria-expanded={isMarketSegmentActive}>
                                <i className="fas fa-chart-line" /><p>Market Segment</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isMarketSegmentActive ? "show" : ""}`} id="MarketSegmentDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Property/MarketSagmentList") ? "active" : ""}>
                                        <NavLink to="/Property/MarketSagmentList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Market Segment List</span>
                                        </NavLink>
                                    </li>

                                </ul>
                            </div>
                        </li>

                        {/* Business Source */}
                        <li className={`nav-item ${isBusinssSourceActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#userDetails" aria-expanded={isBusinssSourceActive}>
                                <i className="fas fa-user" /><p>Business Source</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isBusinssSourceActive ? "show" : ""}`} id="userDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Property/BusinessSourceList") ? "active" : ""}>
                                        <NavLink to="/Property/BusinessSourceList" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Business Source List</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>


                        <li className={`nav-item ${isGuaranteeCodesActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#guaranteeCodes" aria-expanded={isGuaranteeCodesActive}>
                                <i className="fas fa-user" /><p>Guarantee Codes</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isGuaranteeCodesActive ? "show" : ""}`} id="guaranteeCodes">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Property/GuaranteeCodes") ? "active" : ""}>
                                        <NavLink to="/Property/GuaranteeCodes" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Guarantee Codes</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className={`nav-item ${isReportActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#Report" aria-expanded={isReportActive}>
                                <i class="fas fa-file-alt" /><p>Report</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isReportActive ? "show" : ""}`} id="Report">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Property/BookingReport") ? "active" : ""}>
                                        <NavLink to="/Property/BookingReport" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Booking Report</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/Report") ? "active" : ""}>
                                        <NavLink to="/Property/Report" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Report</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Property/TodayBookingReport") ? "active" : ""}>
                                        <NavLink to="/Property/TodayBookingReport" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Today Booking Report</span>
                                        </NavLink>
                                    </li>

                                    <li className={isPathActive("/Property/AgentReport") ? "active" : ""}>
                                        <NavLink to="/Property/AgentReport" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Agent Booking Report</span>
                                        </NavLink>
                                    </li>

                                    <li className={isPathActive("/Property/CorporateBookingReport") ? "active" : ""}>
                                        <NavLink to="/Property/CorporateBookingReport" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Corporate Booking Report</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>


                    </ul>
                </div>
            </div>
        </div>
    );
};

export default SideBar;
